import { FIREBASE_SERVICE_PAGE_ID_NAME } from './remoteConfig';

const VERTICAL_BRIDGE_SERVICES = {
  [`${FIREBASE_SERVICE_PAGE_ID_NAME}`]: [
    {
      service: 'my',
      url: 'https://my.tmapmobility.com/web/all_services',
    },
    {
      service: 'weather',
      url: 'https://m.tmobiweb.com/view/web/weather',
    },
    {
      service: 'insurance',
      url: 'https://api3.tnkfactory.com/tnk/offerwall.web.main?md_user_nm={tmap.uuid}&app_id=d0e07020-50d1-f948-849f-1c090d010b07&oid=607623a6943219b5a201efff5e459def&t=1',
      iosUrl:
        'https://api3.tnkfactory.com/tnk/offerwall.web.main?md_user_nm={tmap.uuid}&app_id=8030e070-80d1-8958-8598-1c0d02040703&oid=607623a6943219b5a201efff5e459def&t=1',
      requestData: ['uuid'],
    },
  ],
  [`${FIREBASE_SERVICE_PAGE_ID_NAME}_dev`]: [
    {
      service: 'verification',
      url: 'https://poi-dev.tmobiweb.com/app/place?productid=verification',
      requestData: ['ak'],
    },
    {
      service: 'pedometer',
      url: 'https://m-dev.tmobiweb.com/view/web/bridge?serviceName=pedometer&id=1&termsGroupCode=TMAP_PEDOMETER',
      minVersion: '10.15.0',
      requestData: ['ak', 'euk', 'deviceid', 'sessionid'],
    },
    {
      service: 'auto-insurance',
      url: 'https://api.pincrux.com/click.pin?appkey=345062&pubkey=912082&cruxkey={tmap.uuid}',
      requestData: ['uuid'],
    },
    {
      service: 'insurance',
      url: 'https://api3.tnkfactory.com/tnk/offerwall.web.main?md_user_nm={tmap.uuid}&app_id=d0e07020-50d1-f948-849f-1c090d010b07&oid=607623a6943219b5a201efff5e459def&t=1',
      iosUrl:
        'https://api3.tnkfactory.com/tnk/offerwall.web.main?md_user_nm={tmap.uuid}&app_id=8030e070-80d1-8958-8598-1c0d02040703&oid=607623a6943219b5a201efff5e459def&t=1',
      requestData: ['uuid'],
    },
    {
      service: 'biz-partner-center-lock',
      url: 'https://m-dev.tmobiweb.com/view/web/bridge?serviceName=biz-partner-center&id=1&termsGroupCode=GROUP_ADS_SIGN&portraitonly=true',
      requestData: ['ak', 'euk', 'deviceid', 'sessionid'],
    },
    {
      service: 'biz-partner-center',
      url: 'https://m-dev.tmobiweb.com/view/web/bridge?serviceName=biz-partner-center&id=1&termsGroupCode=GROUP_ADS_SIGN',
      requestData: ['ak', 'euk', 'deviceid', 'sessionid'],
    },
    {
      service: 'my',
      url: 'https://tmobi-my-dev.tmapmobility.com/web/all_services',
    },
    {
      service: 'weather',
      url: 'https://m-dev.tmobiweb.com/view/web/weather',
    },
    {
      service: 'dgtourcard',
      url: 'https://m-dev.tmobiweb.com/view/web/dgtourcard?portraitonly=true',
    },
    {
      service: 'mygroups',
      url: 'https://tmobi-mygroups-dev.tmapmobility.com',
    },
    {
      service: 'openAgreementDialog',
      url: 'https://m-dev.tmobiweb.com/view/web/agreement/test',
    },
    {
      service: 'terms',
      url: 'https://m-dev.tmobiweb.com/view/web/bridge?serviceName=pointshop&id=MjAyNTA4&termsGroupCode=TMAP_PSH_SIGNUP',
      requestData: ['ak', 'euk', 'deviceid', 'sessionid'],
    },
    {
      service: 'couponList',
      url: 'https://poi-dev.tmobiweb.com/app/poi/coupon/storage',
    },
    {
      service: 'tmapweb-3937',
      minVersion: '10.13.4',
      maxVersion: '10.13.4',
      url: 'https://uw-dev.tmobiweb.com/m/cs',
      altUrl: 'https://m-dev.tmobiweb.com/view/web/general/close?pageid=pickup',
      requestData: ['ak'],
    },
    {
      service: 'pedometer',
      url: 'https://tmobi-my-dev.tmapmobility.com/web/step_counter',
      minVersion: '10.10.0',
      maxVersion: '10.14.0',
      altUrl: 'https://m-dev.tmobiweb.com/view/web/general/close?pageid=pickup',
      requestData: ['ak'],
    },
  ],
  [`${FIREBASE_SERVICE_PAGE_ID_NAME}_stg`]: [
    {
      service: 'verification',
      url: 'https://poi-dev.tmobiweb.com/app/place?productid=verification',
      requestData: ['ak'],
    },
    {
      service: 'pedometer',
      url: 'https://m-dev.tmobiweb.com/view/web/bridge?serviceName=pedometer&id=1&termsGroupCode=TMAP_PEDOMETER',
      minVersion: '10.15.0',
      requestData: ['ak', 'euk', 'deviceid', 'sessionid'],
    },
    {
      service: 'auto-insurance',
      url: 'https://api.pincrux.com/click.pin?appkey=345062&pubkey=912082&cruxkey={tmap.uuid}',
      requestData: ['uuid'],
    },
    {
      service: 'insurance',
      url: 'https://api3.tnkfactory.com/tnk/offerwall.web.main?md_user_nm={tmap.uuid}&app_id=d0e07020-50d1-f948-849f-1c090d010b07&oid=607623a6943219b5a201efff5e459def&t=1',
      iosUrl:
        'https://api3.tnkfactory.com/tnk/offerwall.web.main?md_user_nm={tmap.uuid}&app_id=8030e070-80d1-8958-8598-1c0d02040703&oid=607623a6943219b5a201efff5e459def&t=1',
      requestData: ['uuid'],
    },
    {
      service: 'biz-partner-center-lock',
      url: 'https://m-dev.tmobiweb.com/view/web/bridge?serviceName=biz-partner-center&id=1&termsGroupCode=GROUP_ADS_SIGN&portraitonly=true',
      requestData: ['ak', 'euk', 'deviceid', 'sessionid'],
    },
    {
      service: 'biz-partner-center',
      url: 'https://m-dev.tmobiweb.com/view/web/bridge?serviceName=biz-partner-center&id=1&termsGroupCode=GROUP_ADS_SIGN',
      requestData: ['ak', 'euk', 'deviceid', 'sessionid'],
    },
    {
      service: 'my',
      url: 'https://tmobi-my-dev.tmapmobility.com/web/all_services',
    },
    {
      service: 'weather',
      url: 'https://m-dev.tmobiweb.com/view/web/weather',
    },
    {
      service: 'dgtourcard',
      url: 'https://m-dev.tmobiweb.com/view/web/dgtourcard?portraitonly=true',
    },
    {
      service: 'mygroups',
      url: 'https://tmobi-mygroups-dev.tmapmobility.com',
    },
    {
      service: 'openAgreementDialog',
      url: 'https://m-dev.tmobiweb.com/view/web/agreement/test',
    },
    {
      service: 'terms',
      url: 'https://m-dev.tmobiweb.com/view/web/bridge?serviceName=pointshop&id=MjAyNTA4&termsGroupCode=TMAP_PSH_SIGNUP',
      requestData: ['ak', 'euk', 'deviceid', 'sessionid'],
    },
    {
      service: 'couponList',
      url: 'https://poi-dev.tmobiweb.com/app/poi/coupon/storage',
    },
    {
      service: 'tmapweb-3937',
      minVersion: '10.13.4',
      maxVersion: '10.13.4',
      url: 'https://uw-dev.tmobiweb.com/m/cs',
      altUrl: 'https://m-dev.tmobiweb.com/view/web/general/close?pageid=pickup',
      requestData: ['ak'],
    },
  ],
  [`${FIREBASE_SERVICE_PAGE_ID_NAME}_rtg`]: [
    {
      service: 'my',
      url: 'https://tmobi-my-rtg.tmapmobility.com/web/all_services',
    },
    {
      service: 'weather',
      url: 'https://m-rtg.tmobiweb.com/view/web/weather',
    },
    {
      service: 'insurance',
      url: 'https://api3.tnkfactory.com/tnk/offerwall.web.main?md_user_nm={tmap.uuid}&app_id=d0e07020-50d1-f948-849f-1c090d010b07&oid=607623a6943219b5a201efff5e459def&t=1',
      iosUrl:
        'https://api3.tnkfactory.com/tnk/offerwall.web.main?md_user_nm={tmap.uuid}&app_id=8030e070-80d1-8958-8598-1c0d02040703&oid=607623a6943219b5a201efff5e459def&t=1',
      requestData: ['uuid'],
    },
  ],
  [`${FIREBASE_SERVICE_PAGE_ID_NAME}_dtg`]: [
    {
      service: 'my',
      url: 'https://tmobi-my-dtg.tmapmobility.com/web/all_services',
    },
    {
      service: 'weather',
      url: 'https://m-dtg.tmobiweb.com/view/web/weather',
    },
    {
      service: 'insurance',
      url: 'https://api3.tnkfactory.com/tnk/offerwall.web.main?md_user_nm={tmap.uuid}&app_id=d0e07020-50d1-f948-849f-1c090d010b07&oid=607623a6943219b5a201efff5e459def&t=1',
      iosUrl:
        'https://api3.tnkfactory.com/tnk/offerwall.web.main?md_user_nm={tmap.uuid}&app_id=8030e070-80d1-8958-8598-1c0d02040703&oid=607623a6943219b5a201efff5e459def&t=1',
      requestData: ['uuid'],
    },
  ],
};

export { VERTICAL_BRIDGE_SERVICES };
